import { FC } from 'react';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { getContrastThemeClass, resolveBackgroundStyle } from '@gn-audio/jss-components';

import { LinkBlockItem } from 'composables/shared/LinkBlock/LinkBlockItem.model';
import { LinkBlockItemComponent } from 'composables/shared/LinkBlock/LinkBlockItemComponent';

export type LinkBlockComponentProps = {
  links: LinkBlockItem[];
  headline: Field<string>;
  backgroundColor: Field<string>;
};

export const LinkBlockComponent: FC<LinkBlockComponentProps> = ({
  links,
  headline,
  backgroundColor,
}) => {
  const containerThemeClass = getContrastThemeClass(backgroundColor?.value);
  const spotBackgroundStyle = resolveBackgroundStyle(backgroundColor?.value);
  return (
    <div
      className={classNames('container-fluid flex flex-col items-center', containerThemeClass)}
      style={spotBackgroundStyle}
    >
      <div className="container !py-0">
        <h2 className="heading-2 mb-6">{headline.value}</h2>
        <div className="grid w-full grid-cols-2 justify-center gap-6 max-lg:grid-cols-1">
          {links.map((block) => (
            <LinkBlockItemComponent key={block.id} block={block} />
          ))}
        </div>
      </div>
    </div>
  );
};
